module.exports = __webpack_public_path__ + "static/vmware_31.6330fee9.jpg";